<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Attendance Policies</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="[getDashboardRoute()]"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Attendance Policy List</li>
        </ol>
      </nav>
    </div>
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      <div class="mb-2 me-2">
        <button
          (click)="openBusiness(addBusinessModal)"
          *appHasPermission="{ attendancePolicy: ['add'] }"
          class="btn btn-primary d-flex align-items-center"
        >
          <i class="ti ti-circle-plus me-2"></i>Create Policy
        </button>
      </div>

      <!-- <div class="mb-2">
        <button
          (click)="openBusiness(assignPolicyModal)"
          *appHasPermission="{ attendancePolicy: ['add'] }"
          class="btn btn-primary d-flex align-items-center"
        >
          <i class="ti ti-circle-plus me-2"></i>Assign Policy
        </button>
      </div> -->
      <div class="head-icons ms-2 d-none">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>Attendance Policy List</h5>
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <div class="me-3" *ngIf="policyList.length > 0">
          <select
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
          </select>
        </div>
        <div class="dropdown me-3">
          <!-- <select
            class="form-select"
            [(ngModel)]="selectedBusiness"
            (change)="getAttendancePolicyList()"
          >
            <option value="" selected>Business Entity</option>
            <option *ngFor="let business of businesses$ | async" [value]="business.id">
              {{ business.businessName | capitalize }}
            </option>
          </select> -->
          <ng-select
            class="me-3"
            [items]="businesses$ | async"
            bindValue="id"
            placeholder="Select Business Entity"
            [searchable]="true"
            [clearable]="true"
            [searchFn]="customSearchFn"
            style="width: 200px"
            [(ngModel)]="selectedBusiness"
            (change)="getAttendancePolicyList()"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.businessName | capitalize }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.businessName | capitalize }}
            </ng-template>
          </ng-select>
        </div>

        <div class="form-sort search-box">
          <label>
            <input
              type="search"
              [(ngModel)]="search"
              (input)="getAttendancePolicyList()"
              class="form-control"
              placeholder="Search"
          /></label>
        </div>
        <!-- Rest of your template -->
      </div>
    </div>
    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <table class="table datatable" *ngIf="policyList.length > 0; else noRecords">
          <thead class="thead-light">
            <tr>
              <!-- <th class="no-sort">
                  <div class="form-check form-check-md">
                    <input class="form-check-input" type="checkbox" id="select-all">
                  </div>
                </th> -->
              <th>Policy</th>
              <th>Shift Type</th>
              <th>Shift Start</th>
              <th>Shift End</th>
              <!--<th>Business Entity</th>-->
              <!-- <th>Status</th> -->
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="policyList && policyList.length > 0">
              <tr *ngFor="let policy of policyList">
                <!-- <td>
                  <div class="form-check form-check-md">
                    <input class="form-check-input" type="checkbox">
                  </div>
                </td> -->
                <td>
                  <h6 class="fw-medium">
                    {{ policy.title }}
                  </h6>
                </td>
                <td>{{ policy.shiftType }}</td>
                <!-- <td>{{ holiday.startDate | date: 'EEE, dd MMM yyyy' }}{{ holiday.endDate != holiday.startDate ? to holiday.endDate | date: 'EEE, dd MMM yyyy' : ''}}</td> -->

                <td>
                  <!-- {{ policy.shiftStartTime ? (policy.shiftStartTime | date: 'hh:mm a') : '' }} -->
                  {{
                    isValidDate(policy.shiftStartTime)
                      ? (policy.shiftStartTime | date: 'hh:mm a')
                      : ''
                  }}
                </td>
                <td>
                  {{
                    isValidDate(policy.shiftEndTime) ? (policy.shiftEndTime | date: 'hh:mm a') : ''
                  }}
                </td>
                <!--<td>{{ policy.business.businessName | capitalize }}</td> -->
                <!-- <td>
                  <span *ngIf="holiday.status == 'Active'"
                    class="badge badge-success d-inline-flex align-items-center badge-xs">
                   Active
                  </span>
                  <span *ngIf="holiday.status != 'Active'"
                    class="badge badge-danger d-inline-flex align-items-center badge-xs">
                   Inactive
                  </span>
                </td> -->
                <td>
                  <div class="action-icon d-inline-flex">
                    <a
                      [routerLink]="[eps.attendance.attendancePolicyDetailsPath, policy.id]"
                      class="me-2"
                      ><i class="ti ti-eye"></i
                    ></a>
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      (click)="openEditPolicy(editBusinessModal, policy)"
                      *appHasPermission="{ attendancePolicy: ['edit'] }"
                      ><i class="ti ti-edit"></i
                    ></a>
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      (click)="setAsDefault(policy)"
                      *appHasPermission="{ attendancePolicy: ['edit'] }"
                      ><i
                        [ngClass]="
                          policy.isDefault ? 'ti ti-star-filled filled text-primary' : 'ti ti-star'
                        "
                      ></i>
                    </a>
                    <!-- <a href="javascript:void(0);" class="me-2"
                      (click)="openBlockUnblock(blockunblockModal, holiday.id, holiday.title , holiday.status)"><i
                        [ngClass]="holiday.status == 'Inactive' ? 'ti ti-lock' : 'ti ti-lock-open-2'"></i></a> -->
                    <a
                      href="javascript:void(0);"
                      (click)="openDelete(deleteModal, policy.id)"
                      *appHasPermission="{ attendancePolicy: ['delete'] }"
                      ><i class="ti ti-trash"></i
                    ></a>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <ng-template #noRecords>
          <div class="text-center">Record not available</div>
        </ng-template>
      </div>
    </div>
    <!-- <div class="has-text-centered mt-3" *ngIf="policyList.length > 0">
        <app-pagination [currentPage]="currentPage" [pageSize]="pageLimit" [totalRows]="totalCount"
          (pageChange)="onPageChange($event)"></app-pagination>
      </div> -->
    <div
      class="d-flex align-items-center justify-content-between ms-2"
      *ngIf="policyList.length > 0"
    >
      <div>
        Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
        {{ totalCount }} entries
        <!-- Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ currentPage * pageLimit }} of
        {{ totalCount }} entries -->
      </div>
      <div class="has-text-centered mt-3">
        <app-pagination
          [currentPage]="currentPage"
          [pageSize]="pageLimit"
          [totalRows]="totalCount"
          (pageChange)="onPageChange($event)"
        ></app-pagination>
      </div>
    </div>
  </div>
</div>

<!-- Add Holiday -->
<ng-template #addBusinessModal let-modal>
  <!-- <div class="modal fade" id="add_holiday">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Add Attendance Policy</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 1"
          (click)="stepChange(1)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 1">Basic Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 1"
            >Basic Information</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 2"
          (click)="stepChange(2)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 2">Shift Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 2"
            >Shift Information</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 3"
          (click)="stepChange(3)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 3">Additional Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 3"
            >Additional Information</a
          >
        </li>
        <!-- <li class="nav-item" role="presentation" [class.active]="currentStep === 4" (click)="stepChange(4)">
            <span class="nav-link" [class.active]="currentStep === 4">Social Profiles</span>
          </li> -->
      </ul>
    </div>
    <div class="tab-content">
      <form [formGroup]="form">
        <fieldset *ngIf="currentStep === 1" id="first-field" class="show-fieldset">
          <div class="contact-input-set">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="businessId" class="col-form-label"
                      >Business Entity <span class="text-danger">*</span></label
                    >
                    <!-- <select class="form-select" formControlName="businessId">
                      <option value="" selected disabled>Select Business Entity</option>
                      <option *ngFor="let business of businesses$ | async" [value]="business.id">
                        {{ business.businessName | capitalize }}
                      </option>
                    </select> -->
                    <ng-select
                      class="me-3 w-100"
                      [items]="businesses$ | async"
                      bindValue="id"
                      placeholder="Select Business Entity"
                      [searchable]="true"
                      [clearable]="true"
                      [searchFn]="customSearchFn"
                      style="width: 200px"
                      formControlName="businessId"
                      appTrimInput
                    >
                      <ng-template ng-label-tmp let-item="item">
                        {{ item.businessName | capitalize }}
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.businessName | capitalize }}
                      </ng-template>
                    </ng-select>
                    <div *ngIf="form.get('businessId')?.invalid && form.get('businessId')?.touched">
                      <span class="text-danger">
                        {{ getErrorMessage('businessId') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="title" class="form-label"
                    >Policy Name <span class="text-danger">*</span></label
                  >
                  <input type="text" class="form-control" formControlName="title" appTrimInput />
                  <div *ngIf="form.get('title')?.invalid && form.get('title')?.touched">
                    <span class="text-danger">
                      {{ getErrorMessage('title') }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="">
                  <div class="input-block">
                    <label for="shiftType" class="col-form-label"
                      >Shift Type <span class="text-danger">*</span></label
                    >
                    <select class="form-select" formControlName="shiftType">
                      <!-- <option value="" selected disabled>Select Type</option> -->
                      <option selected [value]="shiftTypeEnum.FixedWeeklyOff">
                        {{ shiftTypeEnum.FixedWeeklyOff }}
                      </option>
                      <option [value]="shiftTypeEnum.FixedShift">
                        {{ shiftTypeEnum.FixedShift }}
                      </option>
                      <option [value]="shiftTypeEnum.SingleShift">
                        {{ shiftTypeEnum.SingleShift }}
                      </option>
                      <option [value]="shiftTypeEnum.FlexibleShift">
                        {{ shiftTypeEnum.FlexibleShift }}
                      </option>
                    </select>
                    <div *ngIf="form.get('shiftType')?.invalid && form.get('shiftType')?.touched">
                      <span class="text-danger">
                        {{ getErrorMessage('shiftType') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- this code is add by shivam -->

              <!-- only show Midnight feild to Fixed shift  -->
              <!-- remove midnight feild for single shift and flexible policy  -->
              <!-- <div class="mb-3" *ngIf="   form.get('shiftType')?.value !== shiftTypeEnum.SingleShift &&
                  form.get('shiftType')?.value !== shiftTypeEnum.FlexibleShift">
               
                <label class="form-label d-block">
                  Does this shift cross midnight?
                  <small class="text-muted d-block">
                    (Auto-calculated based on start & end time)
                  </small>
                </label>

               
                <div class="form-check mt-2">
                  <input class="form-check-input" type="checkbox" formControlName="isMidnightShift" [disabled]="true" />
                  <label class="form-check-label ms-2">
                    Yes
                  </label>
                </div>
              </div>


              <div class="form-check form-switch">
                <label class="form-check-label"> If You Have to Show OverTime
                  <input type="checkbox" class="form-check-input" formControlName="isOvertimeEnabled" />
                  {{ form.get('isOvertimeEnabled')?.value ? 'Yes' : 'No' }}
                </label>
              </div> -->

              <div class="row g-3 mb-4">
                <!-- Midnight Shift -->
                <div
                  class="col-md-6"
                  *ngIf="
                    form.get('shiftType')?.value !== shiftTypeEnum.SingleShift &&
                    form.get('shiftType')?.value !== shiftTypeEnum.FlexibleShift
                  "
                >
                  <div class="rounded p-3 h-100">
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="form-label mb-0"> Does this shift cross midnight? </label>

                      <div class="form-check form-switch m-0">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="isMidnightShift"
                        />
                      </div>
                    </div>

                    <small class="text-muted d-block mt-1">
                      (Auto-calculated based on start & end time)
                    </small>
                  </div>
                </div>

                <!-- Overtime -->
                <div class="col-md-6">
                  <div class="rounded p-3 h-100">
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="form-label mb-0"> Show Overtime </label>

                      <div class="d-flex align-items-center">
                        <input
                          type="checkbox"
                          class="form-check-input me-2"
                          formControlName="isOvertimeEnabled"
                        />
                        <span>
                          {{ form.get('isOvertimeEnabled')?.value ? 'Yes' : 'No' }}
                        </span>
                      </div>
                    </div>

                    <small class="text-muted d-block mt-1">
                      (If you want to show overtime in dashboard)
                    </small>
                  </div>
                </div>
              </div>

              <div
                class="col-md-6 mt-4"
                *ngIf="
                  form.get('shiftType')?.value !== shiftTypeEnum.SingleShift &&
                  form.get('shiftType')?.value !== shiftTypeEnum.FlexibleShift
                "
              >
                <div class="mb-3">
                  <label for="shiftStartTime" class="form-label"
                    >Shift Start Time <span class="text-danger">*</span></label
                  >
                  <!-- <div class="input-icon-end position-relative"> -->
                  <input
                    type="time"
                    class="form-control"
                    formControlName="shiftStartTime"
                    appTrimInput
                  />
                  <!-- <span class="input-icon-addon">
                        <i class="ti ti-calendar text-gray-7"></i>
                      </span> -->
                  <!-- </div> -->
                  <div
                    *ngIf="
                      form.get('shiftStartTime')?.invalid && form.get('shiftStartTime')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('shiftStartTime') }}
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="col-md-6 mt-4"
                *ngIf="
                  form.get('shiftType')?.value !== shiftTypeEnum.SingleShift &&
                  form.get('shiftType')?.value !== shiftTypeEnum.FlexibleShift
                "
              >
                <div class="mb-3">
                  <label for="shiftEndTime" class="form-label"
                    >Shift End Time <span class="text-danger">*</span></label
                  >
                  <!-- <div class="input-icon-end position-relative"> -->
                  <input
                    type="time"
                    class="form-control"
                    formControlName="shiftEndTime"
                    appTrimInput
                  />
                  <!-- <span class="input-icon-addon">
                        <i class="ti ti-calendar text-gray-7"></i>
                      </span> -->
                  <!-- </div> -->
                  <div
                    *ngIf="form.get('shiftEndTime')?.invalid && form.get('shiftEndTime')?.touched"
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('shiftEndTime') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="description" class="form-label"
                    >Description<span class="text-danger">*</span></label
                  >
                  <textarea
                    appTrimInput
                    class="form-control"
                    rows="3"
                    formControlName="description"
                  ></textarea>
                  <div *ngIf="form.get('description')?.invalid && form.get('description')?.touched">
                    <span class="text-danger">
                      {{ getErrorMessage('description') }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!isStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset *ngIf="currentStep === 2" class="show-fieldset">
          <div class="contact-input-set">
            <div class="row">
              <div class="col-md-12 mb-2">
                <h6>Which days of the week are weekly offs?</h6>
                <p>
                  Weekly off is a day in the week when the person is not expected to work or come to
                  the office.
                </p>
                <div class="btn-list">
                  <label for="weeklyOffs" class="form-label me-3"
                    >Select the day(s) of the week for weekly off</label
                  >
                  <button
                    *ngFor="let day of days"
                    type="button"
                    [ngClass]="
                      day.active ? 'btn btn-soft-dark btn-sm' : 'btn btn-soft-light btn-sm'
                    "
                    (click)="toggleDisabled(day)"
                  >
                    {{ day.label }}
                  </button>
                  <!-- <button type="button" class="btn  btn-soft-light btn-sm">M</button>
                    <button type="button" class="btn  btn-soft-light btn-sm">T</button>
                    <button type="button" class="btn  btn-soft-light btn-sm">W</button>
                    <button type="button" class="btn  btn-soft-light btn-sm">T</button>
                    <button type="button" class="btn  btn-soft-light btn-sm">F</button>
                    <button type="button" class="btn  btn-soft-light btn-sm">S</button>
                    <button type="button" class="btn  btn-soft-light btn-sm">S</button> -->
                  <!-- <button type="button" class="btn  btn-square btn-dark btn-sm">Dark</button> -->
                </div>
              </div>

              <!-- Week Selector for Fixed Shift -->
              <div
                class="col-md-12 mt-3"
                *ngIf="form.get('shiftType')?.value === shiftTypeEnum.FixedShift"
              >
                <ng-container *ngFor="let day of days">
                  <div *ngIf="day.active" class="mb-2">
                    <label [for]="'weeks-' + day.value" class="form-label">{{ day.value }} :</label>
                    <div class="btn-group btn-group-sm" [id]="'weeks-' + day.value">
                      <button
                        *ngFor="let week of weekOptions"
                        type="button"
                        class="btn"
                        [ngClass]="day.weeks.includes(week.value) ? 'btn-dark' : 'btn-light'"
                        (click)="toggleWeekSelection(day, week.value)"
                      >
                        {{ week.label }}
                      </button>
                    </div>
                  </div>
                </ng-container>
              </div>
              <!-- Add Shift Button -->
              <!-- Add Shift Button visible only for SingleShift  and flexible shift -->
              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  class="btn btn-sm btn-primary wizard-next-btn p-2 mb-2"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightAddShift"
                  aria-controls="offcanvasRightAddShift"
                  *ngIf="
                    form.get('shiftType')?.value === shiftTypeEnum.SingleShift ||
                    form.get('shiftType')?.value === shiftTypeEnum.FlexibleShift
                  "
                  (click)="openAddShift()"
                >
                  Add Shift
                </button>
              </div>

              <!-- List of Added Shifts -->
              <!-- <div *ngFor="let shift of shiftRecords.controls; let i = index" class="btn btn-sm btn-primary wizard-next-btn p-2 mb-2 d-inline-block">
                
                Shift {{ i + 1 }}
              </div> -->

              <div class="d-flex flex-wrap gap-2 mb-2">
                <div
                  *ngFor="let shift of shiftRecords.controls; let i = index"
                  class="btn btn-sm btn-primary wizard-next-btn p-2"
                >
                  Shift {{ i + 1 }}
                </div>
              </div>

              <hr class="border-1 border-dark" style="opacity: 0.1" />

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isBreakHour" class="form-label col-lg-12"
                    >Do you want to give break hours between the work hours?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="isBreakHour"
                      id="workhoursyes"
                      [value]="true"
                      formControlName="isBreakHour"
                    />
                    <label class="form-check-label" for="workhoursyes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="isBreakHour"
                      id="workhoursno"
                      [value]="false"
                      formControlName="isBreakHour"
                    />
                    <label class="form-check-label" for="workhoursno"> No </label>
                  </div>

                  <div *ngIf="isBreakHoursStatus === true" class="ms-3">
                    <label for="breakHour" class="form-label text-gray"
                      >Break Hours <span class="text-danger">*</span></label
                    >
                    <input
                      type="number"
                      class="form-control"
                      formControlName="breakHour"
                      appTrimInput
                      min="0"
                      max="24"
                    />
                  </div>
                </div>
              </div>
              <hr class="border-1 border-dark" style="opacity: 0.1" />
              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  class="btn btn-secondary wizard-prev-btn me-3"
                  [disabled]="!isStepValid()"
                  (click)="stepChange(1)"
                >
                  Previous
                </button>
                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!isStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset *ngIf="currentStep === 3" class="show-fieldset">
          <div class="contact-input-set">
            <div class="row">
              <!-- <div class="col-md-12 mb-2">
                <label class="form-label col-lg-12">Is a single clock-in sufficient for the employee to be marked full
                  day present?

                  <div class="form-check form-check-inline form-check-md form-switch me-2">
                    <label class="form-check-label mt-0">
                      <input class="form-check-input me-2" type="checkbox" role="switch"
                        (change)="toggleisSingleClockIn()" formControlName="isSingleClockIn" />
                      {{ isSingleClockInStatus === true ? 'Yes' : 'No' }}
                    </label>
                  </div>
                </label>
                <p class="text-gray">
                  (If employee forgot to punch out then also he will be marked as full day present
                  if Yes is selected.)
                </p>
              </div> -->

              <div class="col-md-12 mb-2">
                <label class="form-label col-lg-12"
                  >Is a single clock-in sufficient for the employee to be marked full day present?
                  <div class="form-check form-check-inline form-check-md form-switch me-2">
                    <label class="form-check-label mt-0">
                      <input
                        class="form-check-input me-2"
                        type="checkbox"
                        role="switch"
                        [checked]="isSingleClockInStatus"
                        [disabled]="isSingleClockInDisabled"
                        (change)="toggleisSingleClockIn()"
                      />
                      {{ isSingleClockInStatus === true ? 'Yes' : 'No' }}
                    </label>
                  </div>
                </label>
                <p class="text-gray">
                  (If employee forgot to punch out then also he will be marked as full day present
                  if Yes is selected.)
                </p>
              </div>
              <hr class="border-1 border-dark" style="opacity: 0.1" />

              <div class="col-md-12 mb-2">
                <label class="form-label col-lg-12"
                  >Do you want the employee to work for a minimum number of hours?
                  <div class="form-check form-check-inline form-check-md form-switch me-2">
                    <label class="form-check-label mt-0">
                      <input
                        class="form-check-input me-2"
                        type="checkbox"
                        role="switch"
                        [checked]="isMinimumWorkHoursStatus"
                        [disabled]="isMinimumWorkHoursDisabled"
                        (change)="toggleisMinimumWorkHours()"
                      />
                      {{ isMinimumWorkHoursStatus === true ? 'Yes' : 'No' }}
                    </label>
                  </div>
                </label>
                <p class="text-gray">
                  Minimum number of hours the employee should work in a day for him to be marked as
                  present
                </p>
                <div *ngIf="isMinimumWorkHoursStatus === true" class="ms-3">
                  <label for="minimumWorkHours" class="form-label text-gray"
                    >Minimum hours for full day</label
                  >
                  <input
                    type="number"
                    class="form-control"
                    formControlName="minimumWorkHours"
                    appTrimInput
                    min="1"
                  />

                  <div
                    *ngIf="
                      form.get('minimumWorkHours')?.touched && form.get('minimumWorkHours')?.invalid
                    "
                  >
                    <small
                      class="text-danger"
                      *ngIf="form.get('minimumWorkHours')?.errors?.['required']"
                    >
                      Minimum work hours is required
                    </small>

                    <small
                      class="text-danger"
                      *ngIf="form.get('minimumWorkHours')?.errors?.['min']"
                    >
                      Minimum work hours must be greater than 0
                    </small>
                  </div>
                </div>
              </div>
              <hr class="border-1 border-dark" style="opacity: 0.1" />

              <div class="col-md-12" *ngIf="isMinimumWorkHoursStatus === true">
                <div class="mb-3">
                  <label for="defineValidClock" class="form-label col-lg-12"
                    >What is the Hours worked calculation method?</label
                  >
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="firstclockin_hours"
                      name="defineValidClock"
                      [value]="defineValidClockEnum.FIRSTCLOCKINLASTCLOCKOUT"
                      formControlName="defineValidClock"
                      for="firstclockin"
                      (change)="toggleDefineValidClock(true)"
                    />
                    <label for="firstclockin" class="form-check-label">
                      <strong>First Punch In Last Punch Out</strong>
                    </label>
                    <p class="text-gray">
                      Difference between first punch in and last punch out is calculated as number
                      of hours worked.
                    </p>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="everyvalidclockin_hours"
                      name="defineValidClock"
                      [value]="defineValidClockEnum.EVERYVALIDCLOCKIN"
                      formControlName="defineValidClock"
                      (change)="toggleDefineValidClock(false)"
                    />
                    <label class="form-check-label" for="everyvalidclockin">
                      <strong>Every Valid Punch In and Punch Out Pair</strong>
                    </label>
                    <p>
                      Every time period (differences) between valid punch in and punch out pair is
                      calculated and summed up, the final value is the number of hours worked.
                    </p>
                  </div>
                </div>
              </div>
              <!-- <hr class="border-1 border-dark" style="opacity: 0.1" /> -->

              <!-- <div class="col-md-12 mb-2">
                <label class="form-label col-lg-12">Do you want the employee to work for a minimum number of hours?

                  <div class="form-check form-check-inline form-check-md form-switch me-2">
                    <label class="form-check-label mt-0">
                      <input class="form-check-input me-2" type="checkbox" role="switch"
                        formControlName="isMinimumWorkHours" (change)="toggleisMinimumWorkHours()" />
                      {{ isMinimumWorkHoursStatus === true ? 'Yes' : 'No' }}
                    </label>
                  </div>
                </label>
                <p class="text-gray">
                  Minimum number of hours the employee should work in a day for him to be marked as
                  present
                </p>
                <div *ngIf="isMinimumWorkHoursStatus === true" class="ms-3">
                  <label for="minimumWorkHours" class="form-label text-gray">Minimum hours for full day</label>
                  <input type="number" class="form-control" formControlName="minimumWorkHours" appTrimInput min="1" />
                </div>
              </div> -->

              <!-- <div class="col-md-12 mb-2">
                <label class="form-label col-lg-12">Do you want the employee to work for a minimum number of hours?
                  <div class="form-check form-check-inline form-check-md form-switch me-2">
                    <label class="form-check-label mt-0">
                      <input class="form-check-input me-2" type="checkbox" role="switch"
                        [checked]="isMinimumWorkHoursStatus" [disabled]="isMinimumWorkHoursDisabled"
                        (change)="toggleisMinimumWorkHours()" />
                      {{ isMinimumWorkHoursStatus === true ? 'Yes' : 'No' }}
                    </label>
                  </div>
                </label>
                <p class="text-gray">
                  Minimum number of hours the employee should work in a day for him to be marked as present
                </p>
                <div *ngIf="isMinimumWorkHoursStatus === true" class="ms-3">
                  <label for="minimumWorkHours" class="form-label text-gray">Minimum hours for full day</label>
                  <input type="number" class="form-control" formControlName="minimumWorkHours" appTrimInput min="1" />
                </div>
              </div>
              <hr class="border-1 border-dark" style="opacity: 0.1" /> -->

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="workDayExtensionMinutes" class="form-label"
                    >What is the Work Day Extension Minutes?</label
                  >
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      formControlName="workDayExtensionMinutes"
                      appTrimInput
                      max="1440"
                      min="0"
                    />
                    <span class="input-group-text">minutes</span>
                  </div>
                  <div
                    *ngIf="
                      form.get('workDayExtensionMinutes')?.invalid &&
                      form.get('workDayExtensionMinutes')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('workDayExtensionMinutes') }}
                    </span>
                  </div>
                </div>
              </div>

              <hr class="border-1 border-dark" style="opacity: 0.1" />

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="firstclockin" class="form-label col-lg-12"
                    >What happens when an employee's first clock-in is after the shift start time
                    (10:00)?</label
                  >
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="firstclockin_time"
                      name="firstClockInAfterTime"
                      [value]="firstClockInTimeType.DOSENOTMETTER"
                      formControlName="firstClockInAfterTime"
                      (click)="toggleFirstclockin('firstclockin')"
                    />
                    <label for="firstclockin" class="form-check-label">
                      {{ firstClockInTimeType.DOSENOTMETTER }}
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="everyvalidclockin_time"
                      name="firstClockInAfterTime"
                      [value]="firstClockInTimeType.CERTAINTIME"
                      formControlName="firstClockInAfterTime"
                      (click)="toggleFirstclockin('everyvalidclockin')"
                    />
                    <label class="form-check-label" for="everyvalidclockin">
                      {{ firstClockInTimeType.CERTAINTIME }}
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="markedlate_time"
                      name="firstClockInAfterTime"
                      [value]="firstClockInTimeType.MARKEDLATE"
                      formControlName="firstClockInAfterTime"
                      (click)="toggleFirstclockin('markedlate')"
                    />
                    <label class="form-check-label" for="markedlate">
                      {{ firstClockInTimeType.MARKEDLATE }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12" *ngIf="firstClockInTimeStatus === true">
                <div class="mb-3">
                  <label for="firstClockInTime" class="form-label text-gray"
                    >First punch in should be before</label
                  >
                  <!-- <input type="time" class="form-control" formControlName="firstClockInTime" appTrimInput min="0" /> -->
                  <input
                    type="number"
                    class="form-control"
                    formControlName="firstClockInTime"
                    min="0"
                    placeholder="Enter minutes (e.g. 15)"
                  />
                </div>
                <div
                  class="text-danger"
                  *ngIf="
                    form.hasError('firstClockInBeforeShift') &&
                    form.get('firstClockInTime')?.touched
                  "
                >
                  First punch-in time cannot be before shift start time
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="isMarkedLateStatus === true">
                <div class="mb-3">
                  <label for="isLossOfPay" class="form-label col-lg-12">Should every Late status result in 1 day of Loss
                    Of Pay (LOP)?
                  </label>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="lospayYes" name="isLossOfPay" value="1"
                      formControlName="isLossOfPay" for="lospayYes" [checked]="isLossOfPayStatus" />
                    <label for="lospayYes" class="form-check-label"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="lospayNo" name="isLossOfPay" value="0"
                      formControlName="isLossOfPay" [checked]="!isLossOfPayStatus" />
                    <label class="form-check-label" for="lospayNo">
                      No, LOP days will be calculated basis a custom rule
                    </label>
                  </div>
                  <div class="contact-input-set" *ngIf="!isLossOfPayStatus">
                    <div class="row">
                      <div class="col-md-6">
                        <label for="lopDays" class="form-label text-gray"></label>
                        <div class="input-group mt-2">
                          <input type="number" class="form-control" formControlName="lopDays" appTrimInput min="0" />
                          <span class="input-group-text">LOP day(s)</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label for="everyLateDays" class="form-label text-gray">for every</label>
                        <div class="input-group">
                          <input type="number" class="form-control" formControlName="everyLateDays" appTrimInput
                            min="0" />
                          <span class="input-group-text">day(s) late</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- Old working code -->
              <!--  
               <div class="col-md-12" *ngIf="isMarkedLateStatus === true">
                <div class="mb-3">
                  <label for="isLossOfPay" class="form-label col-lg-12">Should every Late status result in 1 day of Loss
                    Of Pay (LOP)?
                  </label>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="lospayYes" name="isLossOfPay" [value]="true"
                      formControlName="isLossOfPay" />
                    <label for="lospayYes" class="form-check-label"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="lospayNo" name="isLossOfPay" [value]="false"
                      formControlName="isLossOfPay" />
                    <label class="form-check-label" for="lospayNo">
                      No, LOP days will be calculated basis a custom rule
                    </label>
                  </div>
                  <div class="contact-input-set" *ngIf="!isLossOfPayStatus">
                    <div class="row">
                      <div class="col-md-4">
                        <label for="lopDays" class="form-label text-gray"></label>
                        <div class="input-group mt-2">
                          <input type="number" class="form-control" formControlName="lopDays" appTrimInput min="0" />
                          <span class="input-group-text">LOP day(s)</span>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label for="everyLateDays" class="form-label text-gray">for every</label>
                        <div class="input-group">
                          <input type="number" class="form-control" formControlName="everyLateDays" appTrimInput
                            min="0" />
                          <span class="input-group-text">day(s) late</span>
                        </div>
                      </div>

                  

                      <div class="col-md-4">
                        <label for="lopCalculationPeriod" class="form-label text-gray">
                          LOP Calculation Period
                        </label>

                        <select class="form-select" formControlName="lopCalculationPeriod">
                          <option *ngFor="let opt of lopOptions" [value]="opt.value">
                            {{ opt.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>  -->

              <!-- New working code change some styling working corectly  21-04-2026 -->

              <div class="col-md-12" *ngIf="isMarkedLateStatus === true">
                <div class="mb-3">
                  <!-- LOP Toggle -->
                  <label class="form-label col-lg-12">
                    Should every Late status result in 1 day of Loss Of Pay (LOP)?
                  </label>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      [value]="true"
                      formControlName="isLossOfPay"
                    />
                    <label class="form-check-label">Yes</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      [value]="false"
                      formControlName="isLossOfPay"
                    />
                    <label class="form-check-label">
                      No, LOP days will be calculated based on custom rule
                    </label>
                  </div>

                  <!-- Custom Rule Section -->
                  <div class="contact-input-set" *ngIf="form.get('isLossOfPay')?.value === false">
                    <div class="row">
                      <!-- LOP Days -->
                      <div class="col-md-4">
                        <label class="form-label text-gray">LOP Days</label>
                        <div class="input-group">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="lopDays"
                            min="0"
                          />
                          <span class="input-group-text">day(s)</span>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <label class="form-label text-gray">For every</label>
                        <div class="input-group">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="everyLateDays"
                            min="1"
                            [max]="form.get('lopCalculationPeriod')?.value === 'WEEK' ? 7 : 31"
                          />
                          <span class="input-group-text">day(s) late</span>
                        </div>

                        <div
                          class="text-danger mt-1"
                          *ngIf="
                            form.get('everyLateDays')?.touched && form.get('everyLateDays')?.errors
                          "
                        >
                          <span *ngIf="form.get('everyLateDays')?.errors?.['max']">
                            Max allowed is
                            {{ form.get('lopCalculationPeriod')?.value === 'WEEK' ? 7 : 31 }}
                            days
                          </span>

                          <span *ngIf="form.get('everyLateDays')?.errors?.['min']">
                            Minimum should be 1
                          </span>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <label class="form-label text-gray"> Calculate LOP Based On </label>

                        <select class="form-select" formControlName="lopCalculationPeriod">
                          <option *ngFor="let opt of lopOptions" [value]="opt.value">
                            {{ opt.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr class="border-1 border-dark" style="opacity: 0.1" />

              <div class="col-md-12 mb-2">
                <label class="form-label col-lg-12"
                  >Do you want your employee to upload a selfie with their punch in/punch out
                  entries?

                  <div class="form-check form-check-inline form-check-md form-switch me-2">
                    <label class="form-check-label mt-0">
                      <input
                        class="form-check-input me-2"
                        type="checkbox"
                        role="switch"
                        formControlName="isSelfie"
                        (change)="toggleisSelfie()"
                      />
                      {{ isSelfieStatus === true ? 'Yes' : 'No' }}
                    </label>
                  </div>
                </label>
                <p class="text-gray">
                  Employees would be prompted to take a picture upon clocking IN/OUT
                </p>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  (click)="onClose()"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="btn btn-secondary wizard-prev-btn me-3"
                  [disabled]="!isStepValid()"
                  (click)="stepChange(2)"
                >
                  Previous
                </button>
                <button
                  type="submit"
                  (click)="onSubmit()"
                  [disabled]="!isStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  <ng-container *ngIf="isLoading; else loading">
                    <span
                      class="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Submit...
                  </ng-container>
                  <ng-template #loading> Submit </ng-template>
                </button>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- /Add Holiday -->

<!-- Add Holiday -->
<ng-template #editBusinessModal let-modal>
  <!-- <div class="modal fade" id="add_holiday">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Edit Attendance Policy</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 1"
          (click)="stepChange(1)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 1">Basic Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 1"
            >Basic Information</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 2"
          (click)="stepChange(2)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 2">Shift Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 2"
            >Shift Information</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 3"
          (click)="stepChange(3)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 3">Additional Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 3"
            >Additional Information</a
          >
        </li>
        <!-- <li class="nav-item" role="presentation" [class.active]="currentStep === 4" (click)="stepChange(4)">
            <span class="nav-link" [class.active]="currentStep === 4">Social Profiles</span>
          </li> -->
      </ul>
    </div>
    <div class="tab-content">
      <form [formGroup]="form">
        <fieldset *ngIf="currentStep === 1" id="first-field" class="show-fieldset">
          <div class="contact-input-set">
            <div class="row">
              <!-- <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="businessId" class="col-form-label"
                      >Business Entity <span class="text-danger">*</span></label
                    >
                    <ng-select
                      class="me-3 w-100"
                      [items]="businesses$ | async"
                      bindValue="id"
                      placeholder="Select Business Entity"
                      [searchable]="true"
                      [clearable]="true"
                      [searchFn]="customSearchFn"
                      style="width: 200px"
                      formControlName="businessId"
                    >
                      <ng-template ng-label-tmp let-item="item">
                        {{ item.businessName | capitalize }}
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.businessName | capitalize }}
                      </ng-template>
                    </ng-select>

                    <div *ngIf="form.get('businessId')?.invalid && form.get('businessId')?.touched">
                      <span class="text-danger">
                        {{ getErrorMessage('businessId') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="title" class="form-label">Policy Name</label>
                  <input type="text" class="form-control" formControlName="title" appTrimInput />
                  <div *ngIf="form.get('title')?.invalid && form.get('title')?.touched">
                    <span class="text-danger">
                      {{ getErrorMessage('title') }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="shiftType" class="col-form-label"
                      >Shift Type <span class="text-danger">*</span></label
                    >
                    <select class="form-select" formControlName="shiftType">
                      <!-- <option value="" selected disabled>Select Type</option> -->
                      <option selected [value]="shiftTypeEnum.FixedWeeklyOff">
                        {{ shiftTypeEnum.FixedWeeklyOff }}
                      </option>
                      <option [value]="shiftTypeEnum.FixedShift">
                        {{ shiftTypeEnum.FixedShift }}
                      </option>
                      <option [value]="shiftTypeEnum.SingleShift">
                        {{ shiftTypeEnum.SingleShift }}
                      </option>
                      <option [value]="shiftTypeEnum.FlexibleShift">
                        {{ shiftTypeEnum.FlexibleShift }}
                      </option>
                    </select>
                    <div *ngIf="form.get('shiftType')?.invalid && form.get('shiftType')?.touched">
                      <span class="text-danger">
                        {{ getErrorMessage('shiftType') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- show ismidnight feild in edit policyt only for fixed shifts  -->
              <!-- remove this feild for single and flexible shift -->
              <!-- <div class="mb-3" *ngIf="   form.get('shiftType')?.value !== shiftTypeEnum.SingleShift &&
                  form.get('shiftType')?.value !== shiftTypeEnum.FlexibleShift">
                 
                 <label class="form-label d-block">
                  Does this shift cross midnight?
                  <small class="text-muted d-block">
                    (Auto-calculated based on start & end time)
                  </small>
                 </label>

            
                <div class="form-check mt-2">
                  <input class="form-check-input" type="checkbox" formControlName="isMidnightShift" [disabled]="true" />
                  <label class="form-check-label ms-2">
                    Yes
                  </label>
                </div>
              </div> -->

              <div class="row g-3">
                <!-- Midnight Shift -->
                <div
                  class="col-md-6"
                  *ngIf="
                    form.get('shiftType')?.value !== shiftTypeEnum.SingleShift &&
                    form.get('shiftType')?.value !== shiftTypeEnum.FlexibleShift
                  "
                >
                  <div class="rounded p-3 h-100">
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="form-label mb-0"> Does this shift cross midnight? </label>

                      <div class="form-check form-switch m-0">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="isMidnightShift"
                        />
                      </div>
                    </div>

                    <small class="text-muted d-block mt-1">
                      (Auto-calculated based on start & end time)
                    </small>
                  </div>
                </div>

                <!-- Overtime -->
                <div class="col-md-6">
                  <div class="rounded p-3 h-100">
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="form-label mb-0"> Show Overtime </label>

                      <div class="d-flex align-items-center">
                        <input
                          type="checkbox"
                          class="form-check-input me-2"
                          formControlName="isOvertimeEnabled"
                        />
                        <span>
                          {{ form.get('isOvertimeEnabled')?.value ? 'Yes' : 'No' }}
                        </span>
                      </div>
                    </div>

                    <small class="text-muted d-block mt-1">
                      (If you want to show overtime in dashboard)
                    </small>
                  </div>
                </div>
              </div>

              <!-- remove this feild for single and flexible shift -->
              <div
                class="col-md-6"
                *ngIf="
                  form.get('shiftType')?.value !== shiftTypeEnum.SingleShift &&
                  form.get('shiftType')?.value !== shiftTypeEnum.FlexibleShift
                "
              >
                <div class="mb-3">
                  <label for="shiftStartTime" class="form-label">Shift Start Time</label>
                  <!-- <div class="input-icon-end position-relative"> -->
                  <input
                    type="time"
                    class="form-control"
                    formControlName="shiftStartTime"
                    appTrimInput
                  />
                  <!-- <span class="input-icon-addon">
                        <i class="ti ti-calendar text-gray-7"></i>
                      </span> -->
                  <!-- </div> -->
                  <div
                    *ngIf="
                      form.get('shiftStartTime')?.invalid && form.get('shiftStartTime')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('shiftStartTime') }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- remove this feild for single and flexible shift -->
              <div
                class="col-md-6"
                *ngIf="
                  form.get('shiftType')?.value !== shiftTypeEnum.SingleShift &&
                  form.get('shiftType')?.value !== shiftTypeEnum.FlexibleShift
                "
              >
                <div class="mb-3">
                  <label for="shiftEndTime" class="form-label">Shift End Time</label>
                  <!-- <div class="input-icon-end position-relative"> -->
                  <input
                    type="time"
                    class="form-control"
                    formControlName="shiftEndTime"
                    appTrimInput
                  />
                  <!-- <span class="input-icon-addon">
                        <i class="ti ti-calendar text-gray-7"></i>
                      </span> -->
                  <!-- </div> -->
                  <div
                    *ngIf="form.get('shiftEndTime')?.invalid && form.get('shiftEndTime')?.touched"
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('shiftEndTime') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="description" class="form-label">Description</label>
                  <textarea
                    class="form-control"
                    rows="3"
                    formControlName="description"
                    appTrimInput
                  ></textarea>
                  <div *ngIf="form.get('description')?.invalid && form.get('description')?.touched">
                    <span class="text-danger">
                      {{ getErrorMessage('description') }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!isStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset *ngIf="currentStep === 2" class="show-fieldset">
          <div class="contact-input-set">
            <div class="row">
              <div class="col-md-12 mb-2">
                <h6>Which days of the week are weekly offs?</h6>
                <p>
                  Weekly off is a day in the week when the person is not expected to work or come to
                  the office.
                </p>
                <div class="btn-list">
                  <label for="weeklyOffs" class="form-label me-3"
                    >Select the day(s) of the week for weekly off</label
                  >
                  <button
                    *ngFor="let day of days"
                    type="button"
                    [ngClass]="
                      day.active ? 'btn btn-soft-dark btn-sm' : 'btn btn-soft-light btn-sm'
                    "
                    (click)="toggleDisabled(day)"
                  >
                    {{ day.label }}
                  </button>
                  <!-- <button type="button" class="btn  btn-soft-light btn-sm">M</button>
                    <button type="button" class="btn  btn-soft-light btn-sm">T</button>
                    <button type="button" class="btn  btn-soft-light btn-sm">W</button>
                    <button type="button" class="btn  btn-soft-light btn-sm">T</button>
                    <button type="button" class="btn  btn-soft-light btn-sm">F</button>
                    <button type="button" class="btn  btn-soft-light btn-sm">S</button>
                    <button type="button" class="btn  btn-soft-light btn-sm">S</button> -->
                  <!-- <button type="button" class="btn  btn-square btn-dark btn-sm">Dark</button> -->
                </div>
              </div>

              <div class="col-lg-12 text-end form-wizard-button">
                <!-- <button type="button" class="btn btn-sm btn-primary wizard-next-btn p-2 mb-2" data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightAddShift" aria-controls="offcanvasRightAddShift" *ngIf="
                    form.get('shiftType')?.value === shiftTypeEnum.SingleShift ||
                    form.get('shiftType')?.value === shiftTypeEnum.FlexibleShift
                  "  
                  >
                  Edit Shift
                </button> -->
              </div>
              <hr class="border-1 border-dark" style="opacity: 0.1" />

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isBreakHour" class="form-label col-lg-12"
                    >Do you want to give break hours between the work hours?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="isBreakHour"
                      id="isBreakHouryes"
                      [value]="true"
                      formControlName="isBreakHour"
                      (change)="toggleBreakhours(true)"
                    />
                    <label class="form-check-label" for="isBreakHouryes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="isBreakHour"
                      id="isBreakHourno"
                      [value]="false"
                      formControlName="isBreakHour"
                      (change)="toggleBreakhours(false)"
                    />
                    <label class="form-check-label" for="isBreakHourno"> No </label>
                  </div>

                  <div *ngIf="isBreakHoursStatus === true" class="ms-3">
                    <label for="breakHour" class="form-label text-gray">Break Hours</label>
                    <input type="number" class="form-control" formControlName="breakHour" min="0" />
                  </div>
                </div>
              </div>
              <hr class="border-1 border-dark" style="opacity: 0.1" />
              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  class="btn btn-secondary wizard-prev-btn me-3"
                  [disabled]="!isStepValid()"
                  (click)="stepChange(1)"
                >
                  Previous
                </button>
                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!isStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset *ngIf="currentStep === 3" class="show-fieldset">
          <div class="contact-input-set">
            <div class="row">
              <!-- <div class="col-md-12 mb-2">
                <label class="form-label col-lg-12">Is a single clock-in sufficient for the employee to be marked full
                  day present?

                  <div class="form-check form-check-inline form-check-md form-switch me-2">
                    <label class="form-check-label mt-0">
                      <input class="form-check-input me-2" type="checkbox" role="switch"
                        formControlName="isSingleClockIn" (change)="toggleisSingleClockIn()" />
                      {{ isSingleClockInStatus === true ? 'Yes' : 'No' }}
                    </label>
                  </div>
                </label>
                <p class="text-gray">
                  (If employee forgot to punch out then also he will be marked as full day present
                  if Yes is selected.)
                </p>
              </div> -->
              <div class="col-md-12 mb-2">
                <label class="form-label col-lg-12"
                  >Is a single clock-in sufficient for the employee to be marked full day present?
                  <div class="form-check form-check-inline form-check-md form-switch me-2">
                    <label class="form-check-label mt-0">
                      <input
                        class="form-check-input me-2"
                        type="checkbox"
                        role="switch"
                        [checked]="isSingleClockInStatus"
                        [disabled]="isSingleClockInDisabled"
                        (change)="toggleisSingleClockIn()"
                      />
                      {{ isSingleClockInStatus === true ? 'Yes' : 'No' }}
                    </label>
                  </div>
                </label>
                <p class="text-gray">
                  (If employee forgot to punch out then also he will be marked as full day present
                  if Yes is selected.)
                </p>
              </div>
              <hr class="border-1 border-dark" style="opacity: 0.1" />

              <div class="col-md-12 mb-2">
                <label class="form-label col-lg-12"
                  >Do you want the employee to work for a minimum number of hours?
                  <div class="form-check form-check-inline form-check-md form-switch me-2">
                    <label class="form-check-label mt-0">
                      <input
                        class="form-check-input me-2"
                        type="checkbox"
                        role="switch"
                        [checked]="isMinimumWorkHoursStatus"
                        [disabled]="isMinimumWorkHoursDisabled"
                        (change)="toggleisMinimumWorkHours()"
                      />
                      {{ isMinimumWorkHoursStatus === true ? 'Yes' : 'No' }}
                    </label>
                  </div>
                </label>
                <p class="text-gray">
                  Minimum number of hours the employee should work in a day for him to be marked as
                  present
                </p>
                <div *ngIf="isMinimumWorkHoursStatus === true" class="ms-3">
                  <label for="minimumWorkHours" class="form-label text-gray"
                    >Minimum hours for full day</label
                  >
                  <input
                    type="number"
                    class="form-control"
                    formControlName="minimumWorkHours"
                    appTrimInput
                    min="1"
                  />
                </div>
              </div>
              <hr class="border-1 border-dark" style="opacity: 0.1" />

              <div class="col-md-12" *ngIf="isMinimumWorkHoursStatus === true">
                <div class="mb-3">
                  <label for="defineValidClock" class="form-label col-lg-12"
                    >What is the Hours worked calculation method?</label
                  >
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="firstclockin_hours"
                      name="defineValidClock"
                      [value]="defineValidClockEnum.FIRSTCLOCKINLASTCLOCKOUT"
                      formControlName="defineValidClock"
                      (change)="toggleDefineValidClock(true)"
                    />
                    <label for="firstclockin" class="form-check-label">
                      <strong>First Punch in Last Punch Out</strong>
                    </label>
                    <p class="text-gray">
                      Difference between first punch in and last punch out is calculated as number
                      of hours worked.
                    </p>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="everyvalidclockin_hours"
                      name="defineValidClock"
                      [value]="defineValidClockEnum.EVERYVALIDCLOCKIN"
                      formControlName="defineValidClock"
                      (change)="toggleDefineValidClock(false)"
                    />
                    <label class="form-check-label" for="everyvalidclockin">
                      <strong>Every Valid Punch In and Punch Out Pair</strong>
                    </label>
                    <p>
                      Every time period (differences) between valid punch in and punch out pair is
                      calculated and summed up, the final value is the number of hours worked.
                    </p>
                  </div>
                </div>
              </div>
              <hr class="border-1 border-dark" style="opacity: 0.1" />

              <!-- <div class="col-md-12 mb-2">
                <label class="form-label col-lg-12">Do you want the employee to work for a minimum number of hours?

                  <div class="form-check form-check-inline form-check-md form-switch me-2">
                    <label class="form-check-label mt-0">
                      <input class="form-check-input me-2" type="checkbox" role="switch"
                        formControlName="isMinimumWorkHours" (change)="toggleisMinimumWorkHours()" />
                      {{ isMinimumWorkHoursStatus === true ? 'Yes' : 'No' }}
                    </label>
                  </div>
                </label>
                <p class="text-gray">
                  Minimum number of hours the employee should work in a day for him to be marked as
                  present
                </p>
                <div *ngIf="isMinimumWorkHoursStatus === true" class="ms-3">
                  <label for="minimumWorkHours" class="form-label text-gray">Minimum hours for full day</label>
                  <input type="number" class="form-control" formControlName="minimumWorkHours" appTrimInput min="0" />
                </div>
              </div> -->

              <!-- <div class="col-md-12 mb-2">
                <label class="form-label col-lg-12">Do you want the employee to work for a minimum number of hours?
                  <div class="form-check form-check-inline form-check-md form-switch me-2">
                    <label class="form-check-label mt-0">
                      <input class="form-check-input me-2" type="checkbox" role="switch"
                        [checked]="isMinimumWorkHoursStatus" [disabled]="isMinimumWorkHoursDisabled"
                        (change)="toggleisMinimumWorkHours()" />
                      {{ isMinimumWorkHoursStatus === true ? 'Yes' : 'No' }}
                    </label>
                  </div>
                </label>
                <p class="text-gray">
                  Minimum number of hours the employee should work in a day for him to be marked as present
                </p>
                <div *ngIf="isMinimumWorkHoursStatus === true" class="ms-3">
                  <label for="minimumWorkHours" class="form-label text-gray">Minimum hours for full day</label>
                  <input type="number" class="form-control" formControlName="minimumWorkHours" appTrimInput min="1" />
                </div>
              </div>
              <hr class="border-1 border-dark" style="opacity: 0.1" /> -->

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="workDayExtensionMinutes" class="form-label"
                    >What is the Work Day Extension Minutes?</label
                  >
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      formControlName="workDayExtensionMinutes"
                      appTrimInput
                      max="1440"
                      min="0"
                    />
                    <span class="input-group-text">minutes</span>
                  </div>
                  <div
                    *ngIf="
                      form.get('workDayExtensionMinutes')?.invalid &&
                      form.get('workDayExtensionMinutes')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('workDayExtensionMinutes') }}
                    </span>
                  </div>
                </div>
              </div>

              <hr class="border-1 border-dark" style="opacity: 0.1" />

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="firstClockInAfterTime" class="form-label col-lg-12"
                    >What happens when an employee's first punch in is after the shift start time
                    (10:00)?</label
                  >
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="firstClockInAfterTime_time"
                      name="firstClockInAfterTime"
                      [value]="firstClockInTimeType.DOSENOTMETTER"
                      formControlName="firstClockInAfterTime"
                      (click)="toggleFirstclockin('firstclockin')"
                    />
                    <label for="firstclockin" class="form-check-label">
                      {{ firstClockInTimeType.DOSENOTMETTER }}
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="everyvalidclockin_time"
                      name="firstClockInAfterTime"
                      [value]="firstClockInTimeType.CERTAINTIME"
                      formControlName="firstClockInAfterTime"
                      (click)="toggleFirstclockin('everyvalidclockin')"
                    />
                    <label class="form-check-label" for="everyvalidclockin">
                      {{ firstClockInTimeType.CERTAINTIME }}
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="markedlate_time"
                      name="firstClockInAfterTime"
                      [value]="firstClockInTimeType.MARKEDLATE"
                      formControlName="firstClockInAfterTime"
                      (click)="toggleFirstclockin('markedlate')"
                    />
                    <label class="form-check-label" for="markedlate">
                      {{ firstClockInTimeType.MARKEDLATE }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12" *ngIf="firstClockInTimeStatus === true">
                <!-- <div class="mb-3">
                  <label for="firstClockInTime" class="form-label text-gray">First punch in should be before</label>
                  <input type="time" class="form-control" formControlName="firstClockInTime" appTrimInput />

                </div> -->

                <div class="mb-3">
                  <label for="firstClockInTime" class="form-label text-gray"
                    >First punch in should be before</label
                  >
                  <!-- <input type="time" class="form-control" formControlName="firstClockInTime" appTrimInput min="0" /> -->
                  <input
                    type="number"
                    class="form-control"
                    formControlName="firstClockInTime"
                    min="0"
                    placeholder="Enter minutes (e.g. 15)"
                  />
                </div>

                <div
                  class="text-danger"
                  *ngIf="
                    form.hasError('firstClockInBeforeShift') &&
                    form.get('firstClockInTime')?.touched
                  "
                >
                  First punch-in time cannot be before shift start time
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="isMarkedLateStatus === true">
                <div class="mb-3">
                  <label for="isLossOfPay" class="form-label col-lg-12">Should every Late status result in 1 day of Loss
                    Of Pay (LOP)?
                  </label>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="lospayYes" name="isLossOfPay" [value]="true"
                      formControlName="isLossOfPay" />
                    <label for="lospayYes" class="form-check-label"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="lospayNo" name="isLossOfPay" [value]="false"
                      formControlName="isLossOfPay" />
                    <label class="form-check-label" for="lospayNo">
                      No, LOP days will be calculated basis a custom rule
                    </label>
                  </div>
                  <div class="contact-input-set" *ngIf="!isLossOfPayStatus">
                    <div class="row">
                      <div class="col-md-6">
                        <label for="lopDays" class="form-label text-gray"></label>
                        <div class="input-group mt-2">
                          <input type="number" class="form-control" formControlName="lopDays" appTrimInput min="0" />
                          <span class="input-group-text">LOP day(s)</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label for="everyLateDays" class="form-label text-gray">for every</label>
                        <div class="input-group">
                          <input type="number" class="form-control" formControlName="everyLateDays" appTrimInput
                            min="0" />
                          <span class="input-group-text">day(s) late</span>
                        </div>
                      </div>

                      
                    </div>

                  </div>



                </div>


              </div> -->

              <div class="col-md-12" *ngIf="isMarkedLateStatus === true">
                <div class="mb-3">
                  <!-- LOP Toggle -->
                  <label class="form-label col-lg-12">
                    Should every Late status result in 1 day of Loss Of Pay (LOP)?
                  </label>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      [value]="true"
                      formControlName="isLossOfPay"
                    />
                    <label class="form-check-label">Yes</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      [value]="false"
                      formControlName="isLossOfPay"
                    />
                    <label class="form-check-label">
                      No, LOP days will be calculated based on custom rule
                    </label>
                  </div>

                  <!-- Custom Rule Section -->
                  <div class="contact-input-set" *ngIf="form.get('isLossOfPay')?.value === false">
                    <div class="row">
                      <!-- LOP Days -->
                      <div class="col-md-4">
                        <label class="form-label text-gray">LOP Days</label>
                        <div class="input-group">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="lopDays"
                            min="0"
                          />
                          <span class="input-group-text">day(s)</span>
                        </div>
                      </div>

                      <!-- Every Late Days -->
                      <div class="col-md-4">
                        <label class="form-label text-gray">For every</label>
                        <div class="input-group">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="everyLateDays"
                            min="1"
                            [max]="form.get('lopCalculationPeriod')?.value === 'WEEK' ? 7 : 31"
                          />
                          <span class="input-group-text">day(s) late</span>
                        </div>

                        <!-- Validation Message -->
                        <div
                          class="text-danger mt-1"
                          *ngIf="
                            form.get('everyLateDays')?.touched && form.get('everyLateDays')?.errors
                          "
                        >
                          <span *ngIf="form.get('everyLateDays')?.errors?.['max']">
                            Max allowed is
                            {{ form.get('lopCalculationPeriod')?.value === 'WEEK' ? 7 : 31 }}
                            days
                          </span>

                          <span *ngIf="form.get('everyLateDays')?.errors?.['min']">
                            Minimum should be 1
                          </span>
                        </div>
                      </div>

                      <!-- Dropdown -->
                      <div class="col-md-4">
                        <label class="form-label text-gray"> Calculate LOP Based On </label>

                        <select class="form-select" formControlName="lopCalculationPeriod">
                          <option *ngFor="let opt of lopOptions" [value]="opt.value">
                            {{ opt.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr class="border-1 border-dark" style="opacity: 0.1" />

              <div class="col-md-12 mb-2">
                <label class="form-label col-lg-12"
                  >Do you want your employee to upload a selfie with their punch in/punch out
                  entries?

                  <div class="form-check form-check-inline form-check-md form-switch me-2">
                    <label class="form-check-label mt-0">
                      <input
                        class="form-check-input me-2"
                        type="checkbox"
                        role="switch"
                        formControlName="isSelfie"
                        (change)="toggleisSelfie()"
                      />
                      {{ isSelfieStatus === true ? 'Yes' : 'No' }}
                    </label>
                  </div>
                </label>
                <p class="text-gray">
                  Employees would be prompted to take a picture upon clocking IN/OUT
                </p>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  (click)="onClose()"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="btn btn-secondary wizard-prev-btn me-3"
                  [disabled]="!isStepValid()"
                  (click)="stepChange(2)"
                >
                  Previous
                </button>
                <button
                  type="submit"
                  (click)="onSubmit()"
                  [disabled]="!isStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  <ng-container *ngIf="isLoading; else loading">
                    <span
                      class="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Submit...
                  </ng-container>
                  <ng-template #loading> Submit </ng-template>
                </button>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- /Add Holiday -->

<!-- block unblock Modal -->
<ng-template #blockunblockModal let-modal>
  <!-- <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content"> -->
  <div class="modal-body text-center">
    <span
      class="avatar avatar-xl mb-3"
      [ngClass]="
        blockUnblockStatus !== 'Active'
          ? 'bg-transparent-danger text-danger'
          : 'bg-transparent-success text-success'
      "
    >
      <i
        [ngClass]="blockUnblockStatus !== 'Active' ? 'ti ti-lock fs-36' : 'ti ti-lock-open-2 fs-36'"
      ></i>
    </span>
    <h4 class="mb-1">Confirm {{ blockUnblockStatus }}</h4>
    <p class="mb-3">
      You want to {{ blockUnblockStatus !== 'Active' ? 'inactive' : 'active' }} the
      <strong>{{ blockTilte }}</strong
      >.
    </p>
    <div class="d-flex justify-content-center">
      <a
        href="javascript:void(0);"
        class="btn btn-light me-3"
        data-bs-dismiss="modal"
        (click)="onClose()"
        >Cancel</a
      >
      <a href="javascript:void(0);" class="btn btn-danger" (click)="confirmBlockUnblock()"
        >Yes, {{ blockUnblockStatus !== 'Active' ? 'Inactive' : 'Active' }}</a
      >
    </div>
  </div>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- /block unblock Modal -->

<!-- Delete Modal -->
<ng-template #deleteModal let-modal>
  <!-- <div class="modal fade" id="delete_modal">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content"> -->
  <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
      <i class="ti ti-trash-x fs-36"></i>
    </span>
    <h4 class="mb-1">Confirm Delete</h4>
    <p class="mb-3">
      You want to delete the attendance policy, this can't be undone once you delete.
    </p>
    <div class="d-flex justify-content-center">
      <a
        href="javascript:void(0);"
        class="btn btn-light me-3"
        data-bs-dismiss="modal"
        (click)="onClose()"
        >Cancel</a
      >
      <a href="javascript:void(0);" class="btn btn-danger" (click)="confirmDelete()">Yes, Delete</a>
    </div>
  </div>
  <!-- </div>
  </div>
  </div> -->
</ng-template>
<!-- /Delete Modal -->

<!-- assign attendance policy -->
<ng-template #assignPolicyModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Assign Attendance Policy</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="assignAttendancePolicyform" (ngSubmit)="onAssign()">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="businessId" class="col-form-label"
                >Business Entity <span class="text-danger">*</span></label
              >
              <!-- <select
                class="form-select"
                formControlName="businessId"
                (change)="onChangePolicyList($event.target)"
              >
                <option value="" selected disabled>Select Business Entity</option>
                <option *ngFor="let business of businesses$ | async" [value]="business.id">
                  {{ business.businessName | capitalize }}
                </option>
              </select> -->
              <ng-select
                class="me-3 w-100"
                [items]="businesses$ | async"
                bindValue="id"
                placeholder="Select Business Entity"
                formControlName="businessId"
                [searchable]="true"
                [clearable]="true"
                [searchFn]="customSearchFn"
                style="width: 200px"
                [(ngModel)]="selectedBusinessId"
                (ngModelChange)="onChangeBusinessPolicyList()"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  assignAttendancePolicyform.get('businessId')?.invalid &&
                  assignAttendancePolicyform.get('businessId')?.touched
                "
              >
                <span class="text-danger">{{ getErrorMessage('businessId') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="attendancePolicyId" class="col-form-label"
                >Attendance Policy <span class="text-danger">*</span></label
              >
              <select
                class="form-select"
                formControlName="attendancePolicyId"
                (change)="onChangeEmployeeList($event.target)"
              >
                <option value="" selected>Select Attendance Policy</option>
                <option *ngFor="let policy of modalPolicyList" [value]="policy.id">
                  {{ policy.title | capitalize }}
                </option>
              </select>
              <div
                *ngIf="
                  assignAttendancePolicyform.get('attendancePolicyId')?.invalid &&
                  assignAttendancePolicyform.get('attendancePolicyId')?.touched
                "
              >
                <span class="text-danger">{{ getErrorMessage('attendancePolicyId') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="employeeIds" class="col-form-label"
                >Employees <span class="text-danger">*</span></label
              >
              <!-- <select
                class="js-select2 form-select"
                multiple="multiple"
                (change)="onEmployeeSelect($event)"
                formControlName="employeeIds"
              >
                <option selected>Select Employees</option>
                <option *ngFor="let employee of employeeList" [value]="employee.id">
                  {{ employee.firstName | capitalize }}
                </option>
              </select> -->
              <ng-select
                class="me-3 w-100"
                multiple
                [items]="employeeList"
                bindValue="id"
                placeholder="Select Employee"
                [searchable]="true"
                [clearable]="true"
                [searchFn]="customSearchFnEmployee"
                style="width: 200px"
                (change)="onEmployeeSelect($event)"
                formControlName="employeeIds"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  assignAttendancePolicyform.get('employeeIds')?.invalid &&
                  assignAttendancePolicyform.get('employeeIds')?.touched
                "
              >
                <span class="text-danger">{{ getErrorMessage('employeeIds') }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Code added by SHIVAM -->

        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label class="col-form-label">
                Assignment Date <span class="text-danger">*</span>
              </label>

              <input
                type="date"
                class="form-control"
                formControlName="assignmentDate"
                [min]="minDate"
                (change)="onAssignmentDateChange($event)"
              />

              <div
                *ngIf="
                  assignAttendancePolicyform.get('assignmentDate')?.invalid &&
                  assignAttendancePolicyform.get('assignmentDate')?.touched
                "
              >
                <span class="text-danger">{{ getErrorMessage('assignmentDate') }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- .CODE ENDED -->
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="!assignAttendancePolicyform.valid">
        <ng-container *ngIf="isLoading; else loading">
          <span
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          Assign...
        </ng-container>
        <ng-template #loading> Assign </ng-template>
      </button>
    </div>
  </form>
</ng-template>

<!-- AddShift offcanvas -->
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="offcanvasRightAddShift"
  aria-labelledby="offcanvasRightAddShiftLabel"
  data-bs-backdrop="true"
  data-bs-keyboard="true"
>
  <div class="offcanvas-header">
    <h5 id="offcanvasRightAddShiftLabel">Add New Shift</h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
  <!-- end offcanvas-header-->

  <div class="offcanvas-body">
    <div *ngIf="showShiftForm" class="offcanvas-panel">
      <form [formGroup]="tempShiftForm">
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label mt-0">Start Time:</label>
              <input class="form-control" formControlName="startTime" type="time" appTrimInput />
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label mt-0">End Time:</label>
              <input class="form-control" formControlName="endTime" type="time" appTrimInput />
            </div>
          </div>

          <div class="col-md-12">
            <div class="mb-3">
              <label class="form-label mt-0 me-3">Days:</label>
              <!-- <div>
              <label *ngFor="let day of days">
                <input
                  type="checkbox"
                  class="form-check"
                  [value]="day.value"
                  (change)="toggleDay(day)"
                  [checked]="selectedDays.includes(day)"
                />
                {{ day.value }}
              </label>
            </div> -->
              <!-- <div class="form-check form-check-inline" *ngFor="let day of days">
                <input class="form-check-input" type="checkbox" name="day" id="day" (change)="toggleDay(day)"
                  [checked]="selectedDays.includes(day)" />
                <label class="form-check-label" for="day"> {{ day.value }} </label>
              </div> -->

              <div class="form-check form-check-inline" *ngFor="let day of availableDays">
                <input
                  class="form-check-input"
                  type="checkbox"
                  (change)="toggleDay(day)"
                  [checked]="selectedDays.includes(day)"
                />
                <label class="form-check-label">
                  {{ day.value }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label for="hasMinHours" class="form-label col-lg-12">Is Full Day?</label>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="isFullDay"
                  id="isFullDayyes"
                  [value]="true"
                  formControlName="isFullDay"
                />
                <label class="form-check-label" for="isFullDayyes"> Yes </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="isFullDay"
                  id="isFullDayno"
                  [value]="false"
                  formControlName="isFullDay"
                />
                <label class="form-check-label" for="isFullDayno"> No </label>
              </div>
            </div>
          </div>

          <!-- <div class="col-md-12 mb-2">
            <label class="form-label col-lg-12"
              >Do you want the employee to work for a minimum number of hours?

              <div class="form-check form-check-inline form-check-md form-switch me-2">
                <label class="form-check-label mt-0">
                  <input
                    class="form-check-input me-2"
                    type="checkbox"
                    role="switch"
                    formControlName="hasMinHours"
                  />
                  {{ tempShiftForm.get('hasMinHours')?.value ? 'Yes' : 'No' }}
                </label>
              </div>
            </label>
            <p class="text-gray">
              Minimum number of hours the employee should work in a day for him to be marked as
              present
            </p>
            <div *ngIf="tempShiftForm.get('hasMinHours')?.value === true" class="ms-3">
              <label for="minimumHours" class="form-label text-gray"
                >Minimum hours for full day</label
              >
              <input
                type="number"
                class="form-control"
                formControlName="minimumHours"
                appTrimInput
                min="1"
              />
            </div>
          </div>

          <div class="col-md-12 mb-2">
            <label class="form-label col-lg-12"
              >Do you want the employee to break hours?

              <div class="form-check form-check-inline form-check-md form-switch me-2">
                <label class="form-check-label mt-0">
                  <input
                    class="form-check-input me-2"
                    type="checkbox"
                    role="switch"
                    formControlName="isBreakHour"
                  />
                  {{ tempShiftForm.get('isBreakHour')?.value ? 'Yes' : 'No' }}
                </label>
              </div>
            </label>
            <div *ngIf="tempShiftForm.get('isBreakHour')?.value === true" class="ms-3">
              <label for="breakHours" class="form-label text-gray">Break Hours</label>
              <input
                type="number"
                class="form-control"
                formControlName="breakHours"
                appTrimInput
                min="1"
                max="24"
              />
            </div>
          </div> -->

          <!-- <div class="col-md-12">
            <div class="mb-3">
              <label class="form-label mt-0">Break Hours:</label>
              <input class="form-control" formControlName="breakHours" type="number" />
            </div>
          </div> -->

          <div class="col-lg-12 text-end form-wizard-button">
            <button type="button" class="btn btn-primary wizard-next-btn" (click)="submitShift()">
              Save Shift
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- end offcanvas-body-->
</div>
<!-- end AddShift offcanvas-->

<!-- assign attendance policy end -->
